import React from 'react';
import { Container, Paper, Toolbar, Box } from '@mui/material';
import { Routes, Route, useParams } from 'react-router-dom';

import Users from './users';
import User, { UserCreate } from './user';

/**
 * Users module router component handling routes for user list, creation, and detail views.
 */
export default function UsersIndex() {
  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route index element={<Users />} />
              <Route path="_create" element={<UserCreate />} />
              <Route path=":id" Component={() => <User id={parseInt(useParams().id!)} />} />
            </Routes>
          </Box>
        </Paper>
      </Container>
    </>
  );
}
